<template>
    <div class="base-welfare" :class="{'welfare-sp': $store.state.screen == 1}">
        <div class="header">
            <div class="nav">
                <div class="item" :class="{isitem: activeNav == index}" v-for="(item, index) in navList" :key="index" @click="onNav(index)">
                    <span>{{item}}</span>
                    <div class="line" v-show="activeNav == index"></div>
                </div>
            </div>
            <img src="~images/share.png" @click="onShare" />
        </div>
        <div class="fixed-bottom">
            <transition name="component-fade" mode="out-in">
                <BaseGiftPack v-if="activeNav == 0" />
                <BaseVoucher v-if="activeNav == 1" />
                <BaseActivity v-if="activeNav == 2" />
            </transition>
        </div>
        <transition name="component-fade" mode="out-in">
            <div class="share-box" :class="{issharebox: isshare == true}">
                <div class="share" :class="{isshare: isshare == true}">
                    <div class="list">
                        <div class="item" v-for="(item, index) in shareList" :key="index">
                            <img :src="item.img" />
                            <div>{{item.name}}</div>
                        </div>
                    </div>
                    <div class="out" @click="onCancel">取消</div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import BaseGiftPack from './BaseGiftPack'
    import BaseVoucher  from './BaseVoucher'
    import BaseActivity from './BaseActivity'

    export default {
        name: 'BaseWelfare',
        components: {
            BaseGiftPack,
            BaseVoucher,
            BaseActivity
        },
        data () {
            return {
                navList: ['礼包', '代金券', '活动'],
                activeNav: 0,
                shareList: [
                    {
                        img: require('images/share_1.png'),
                        name: '朋友圈'
                    },
                    {
                        img: require('images/share_2.png'),
                        name: '微信好友'
                    },
                    {
                        img: require('images/share_3.png'),
                        name: 'QQ好友'
                    },
                    {
                        img: require('images/share_4.png'),
                        name: '新浪微博'
                    }
                ],
                isshare: false
            }
        },
        methods: {
            onNav (index) {
                this.activeNav = index
            },
            onShare () {
                this.isshare = true
            },
            onCancel () {
                this.isshare = false
            }
        }
    }
</script>

<style lang="scss" scoped>
    $color: #FF6C22; // 主体颜色
    // 横屏css
    .base-welfare {
        width: 1080px;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        flex-direction: column;
        position: relative;
        transition: all 0.3s;
        .header {
            height: 132px;
            background: rgba($color, 0.8);
            padding: 0 60px;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: space-between;
            .nav {
                height: 100%;
                display: flex;
                align-items: center;
                .item {
                    height: 100%;
                    font-size: 36px;
                    margin-right: 120px;
                    transition: all 0.1s;
                    display: flex;
                    align-items: center;
                    position: relative;
                }
                .isitem {
                    font-size: 51px;
                }
                .line {
                    width: 30px;
                    height: 10px;
                    background: #fff;
                    position: absolute;
                    bottom: 0;
                    left: 40%;
                    -moz-transform: skewX(-45deg);
                    -ms-transform: skewX(-45deg);
                    -webkit-transform: skewX(-45deg);
                    transform: skewX(-45deg);
                }
            }
            img {
                width: 192px;
                height: 72px;
            }
        }
        .fixed-bottom {
            flex: 1;
            overflow-y: scroll;
            position: relative;
        }
        .share-box {
            width: 1080px;
            background: rgba(0, 0, 0, 0.7);
            transition: all 0.3s;
            position: fixed;
            bottom: 0;
        }
        .issharebox {
            height: 100%;
            z-index: 1;
        }
        .share {
            width: 1080px;
            height: 420px;
            border-radius: 60px 60px 0px 0px;
            background: rgba(255, 255, 255, 0.8);
            transition: all 0.3s;
            position: absolute;
            bottom: -420px;
            display: flex;
            flex-direction: column;
            .list {
                height: 300px;
                border-bottom: 1px solid rgba(0, 0, 0, 0.2);
                display: flex;
                justify-content: space-around;
                .item {
                    color: #333;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    font-size: 36px;
                }
                .item img {
                    width: 120px;
                    height: 120px;
                    margin: 20px 0 15px;
                }
            }
            .out {
                flex: 1;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 39px;
                color: $color;
            }
        }
        .isshare {
            bottom: 0;
        }
    }
    // 竖屏css
    .welfare-sp {
        width: 100%;
        height: 100%;
        .header {
            height: 240px;
            padding: 0 80px;
            border-radius: 60px 0 0 0;
            .nav {
                .item {
                    font-size: 65px;
                    margin-right: 150px;
                }
                .isitem {
                    font-size: 92px;
                }
                .line {
                    width: 54px;
                    height: 18px;
                    left: 40%;
                }
            }
            img {
                width: 349px;
                height: 130px;
            }
        }
        .share-box {
            width: 82%;
            border-radius: 60px 0 0 0;
        }
        .issharebox {
            height: 80%;
        }
        .share {
            width: 100%;
            height: 730px;
            border-radius: 90px 90px 0px 0px;
            bottom: -730px;
            .list {
                height: 530px;
                .item {
                    font-size: 65px;
                }
                .item img {
                    width: 200px;
                    height: 200px;
                    margin: 36px 0 27px;
                }
            }
            .out {
                font-size: 70px;
            }
        }
        .isshare {
            bottom: 0;
        }
    }
</style>